<template>
    <div>
        <collection-header></collection-header>
        <div class="collection-page d-flex">
            <div class="left-side">
                <instagram-widget></instagram-widget>
            </div>

            <div class="collections">
                <h1>All collection</h1>
                <template v-for="(collection, idx) in collections">
                    <a class="collection" :href="'/collections/' + collection.id">
                        <p class="name">{{collection.name}}</p>
                        <span>{{ collection.collection_applications.length }} / update {{ collection.updated_at | moment("DD.MM.YYYY") }}</span>
                        <div class="image">
                            <img :src="collection.image">
                        </div>

                    </a>
                </template>
                <div class="mobile-instagram-widget">
                    <instagram-widget></instagram-widget>
                </div>
            </div>
        </div>
        <mobile-menu></mobile-menu>
    </div>
</template>

<script>
import CollectionHeader from './custom/CollectionHeaderComponent';
import MobileMenu from './custom/MobileMenuComponent';

export default {
    components: {
        CollectionHeader,
        MobileMenu
    },
    data() {
        return {
            collections: []
        };
    },
    mounted() {
        this.loadCollections();
    },
    methods: {
        loadCollections: function (page = 1) {
            axios.get("/api/collections").then(response => {
                this.collections = response.data;
            });
        },
    },

}

</script>
